import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fb--sprite",
  "use": "fb--sprite-usage",
  "viewBox": "0 0 9 20",
  "content": "<symbol viewBox=\"0 0 9 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"fb--sprite\">\n    <path d=\"M7.87112 11.165L8.30766 7.57281H5.5769V5.24167C5.5769 4.25891 5.95834 3.30097 7.18147 3.30097H8.42305V0.242718C8.42305 0.242718 7.29626 0 6.21902 0C3.96995 0 2.49999 1.72039 2.49999 4.83495V7.57281H0V11.165H2.49999V19.849C3.00128 19.9483 3.51506 20 4.03845 20C4.56183 20 5.07562 19.9483 5.5769 19.849V11.165H7.87112Z\" fill=\"#3D3D3D\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol